import React from 'react'
import { Box } from 'particles'
export default props => <Box {...props} />


// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Box/index.js